<template>
  <div class="tags-tab">
    <el-tabs
      v-model="activeRouter"
      @tab-click="handleClick"
      closable
      @tab-remove="closeSelectedTag"
    >
      <el-tab-pane
        :label="generateTitle(tag.name)"
        :name="tag.path"
        v-for="tag in visitedViews"
        :key="tag.path"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { generateTitle } from "@/utils/i18n";
import { find } from "lodash";

export default {
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      activeRouter: this.$route.path,
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    // activeRouter() {
    //   return this.$route.path;
    // }
  },
  watch: {
    $route() {
      this.addViewTags();
      // this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    this.addViewTags();
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path;
    },
    handleClick() {
      console.log(this.activeRouter);
      this.$router.push({
        path: this.activeRouter,
      });
    },
    addViewTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch("addView", this.$route).then(() => {
          this.activeRouter = this.$route.path;
        });
      }
      return false;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);

            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("updateVisitedView", this.$route);
            }

            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch("delCachedView", view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: fullPath,
          });
        });
      });
    },
    closeSelectedTag(path) {
      const view = find(this.visitedViews, { path });
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          const latestView = visitedViews.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView);
          } else {
            this.$router.push({
              name: "home",
            });
            this.addViewTags();
          }
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store.dispatch("delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags() {
      this.$store.dispatch("delAllViews");
      this.$router.push("/");
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left;
      const offsetWidth = this.$el.offsetWidth;
      const maxLeft = offsetWidth - menuMinWidth;
      const left = e.clientX - offsetLeft + 15;

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }
      this.top = e.clientY;

      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    generateTitle,
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.tags-tab {
  .el-tabs__active-bar {
    bottom: 1px;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 64px;
  }
  .el-tabs__item {
    font-size: 14px;
    color: #17181a;
    font-weight: normal;
    height: 64px;
    line-height: 64px;
    &.is-active,
    &:hover {
      color: #3399ff;
    }
    &.is-closable {
      .el-icon-close {
        color: #8a9199;
        // visibility: hidden;
      }
    }
    // &:hover {
    //   .el-icon-close {
    //     visibility: visible;
    //   }
    // }
  }
}
</style>
